module.exports = __webpack_public_path__ + "static/media/srm.bcefc205.svg";